import React from 'react';
import { useSelector } from 'react-redux';
import { SText } from 'src/components/SText';
import { organizationSettingsSelector } from 'src/features/appSettings';
import { $colors } from 'src/theme';
import { ocmSelector } from '../store';

type Props = {
  testID?: string;
};

export const OCMNavBar: React.FC<Props> = ({ testID = 'OCMNavBar' }) => {
  const ocm = useSelector(ocmSelector);
  const orgSettings = useSelector(organizationSettingsSelector);

  if (ocm.firstLoad) {
    return null;
  }

  if (!orgSettings) {
    return null;
  }

  if (!orgSettings.smsEnabled) {
    return null;
  }

  if (ocm.isLoading) {
    return null;
  }

  if (ocm.error) {
    return null;
  }

  if (ocm.data.currentConsumptionAmount > ocm.data.minimalAmount) {
    return null;
  }

  const danger = ocm.data.currentConsumptionAmount === 0;

  return (
    <div
      data-testId={testID}
      style={{ backgroundColor: danger ? $colors.error : $colors.warning }}
      className="w-full py-6 px-4"
    >
      <SText
        label={danger ? 'fr-out-of-amount-out-danger' : 'fr-out-of-amount-warning'}
        translatingOptions={{ minimalAmount: ocm.data.minimalAmount }}
        style={{ color: $colors.white }}
      />
    </div>
  );
};
